import React from "react";
import { BaseCard } from "../../components/base-card";
import styles from "./services.module.scss"
import {ReactComponent as Image1} from "../../assests/images/man-working-on-laptop.svg";


const ServicesPage = () => {
  return (
    <div >
      <h2 style={{color:"#23a9ff"}}>Our Services</h2>
      <BaseCard title=" Leadership Hiring" wrapperClassName={styles["card-wrapper"]}>
        <div  className={styles["content-wrapper"]}>
           <Image1 className={styles["image-container"]} />
         <p> Organisations keep looking at hiring good leaders as part of their
          growth strategy. The challenge is to get appropriate alignment of
          leader's aspirations with the directions of the organization. We, at
          Shivant consultancy, bring in expertise, network and market research to
          our clients in identifying suitable leaders for their organization.For  more information on our leadership hiring services, please contact us.</p>
         
        </div>
      </BaseCard>
      <BaseCard title="Permanent Staffing" wrapperClassName={styles["card-wrapper"]}>
        <div className={styles["content-wrapper"]}> 
        <p>  We provide the agility businesses need with a continuum of staffing
          solutions. By leveraging our trusted brands, we have built a deeper
          talent pool to provide our clients access to the people they need,
          faster. We effectively assess and develop skills, keeping our
          associates ahead of the curve, so they can get the jobs done each
          time, every time.</p>
          <Image1 className={styles["image-container"]} />
        </div>
      </BaseCard>
      <BaseCard title="Contract Staffing" wrapperClassName={styles["card-wrapper"]}>
      <div className={styles["content-wrapper"]}>
      <Image1 className={styles["image-container"]} />
        <p>
          We work with some of the most premier brands around the world,
          including as well as small to mid-sized corporations full of growth
          potential.We’ve recently instituted a team of experts who consult
          clients keen on changing their current vendor. We administer a series
          of measures to ensure we transition the customer from their existing
          vendor to us with minimum impact to business, lesser time and with
          minimum wastage of resources and cost spent
        </p>
        </div>
      </BaseCard>
      <BaseCard title="Specialist Services" wrapperClassName={styles["card-wrapper"]}>
      <div className={styles["content-wrapper"]}> 
        <p>
          At Specialist Services you will join people who share ideas and work
          productively; people who like what they do. Our robust people
          management practices and shared values and behaviours enable us to
          create an ideal work environment. As our product line grows and our
          geographical presence widens, we provide added value for our
          customers, new business opportunities, continued innovation and
          stronger relationships with our business partners. What does this mean
          for your career? Unlimited possibilities.
        </p>
        <Image1 className={styles["image-container"]} />
        </div>
      </BaseCard>
    </div>
  );
};

export default ServicesPage;
